module.exports = __webpack_public_path__ + "img/logo2.a2158e69.png";